// libraries
import store from '@/store/store'
import Vue from 'vue'
import conversation from './conversation'

const resource = 'case'
const resourceName = 'caso'
const resourceNamePlural = 'casos'

const state = {
  messages: [],
  case_object: {},
  isUpdating: false,
  timeout: null,
  filters: {
    caseType: { value: 'all', name: 'Todos' },
    unread: false,
    case_statuses: [],
    platforms: [],
    admins: [],
    groups: [],
    dates: {
      updatedAt: null,
      updatedAtEnd: null,
      last_message_tim: null,
      last_message_time_end: null
    }
  },
  case_events_filters: {
    event_types: [],
    event_names: []
  }
}

state[resource + 's'] = []

// functions receive state
const getters = {
  loading (state) {
    return state.isUpdating
  },
  selectedPlatformsIds (state) {
    return Array.isArray(state.filters.platforms) ? state.filters.platforms.map(p => p.platform_id).join(',') : ''
  },
  selectedStatuses (state) {
    return Array.isArray(state.filters.case_statuses) ? state.filters.case_statuses.join(',') : ''
  },
  selectedAdminsIds (state) {
    return Array.isArray(state.filters.admins) ? state.filters.admins.map(f => f.admin_id).join(',') : ''
  },
  selectedEventTypes (state) {
    return Array.isArray(state.case_events_filters.event_types) ? state.case_events_filters.event_types.join(',') : ''
  },
  selectedEventNames (state) {
    return Array.isArray(state.case_events_filters.event_names) ? state.case_events_filters.event_names.join(',') : ''
  },
  selectedGroupsIds(state) {
    return Array.isArray(state.filters.groups) ? state.filters.groups.map(f => f.group_id).join(',') : ''
  },
  selectedCaseType(state) {
    return state.filters.caseType.value
  }
}

// functions receive context and params
const actions = {
  async all ({ commit }, params) {
    try {
      commit('setItems', [])
      const res = await Vue.request.get(`account/${params.account_id}/${resource}s`, { params: params.params || {} })
      if (res.data.success) {
        commit('setItems', res.data.resource)
        if (params.callback) { params.callback(res.data) }
      } else {
        if (params.callback) { params.callback({ error: `Error obteniendo ${resourceNamePlural}.` }) }
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo ${resourceNamePlural}.` }) }
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      if (!params.soft) { commit('setCase', {}) }
      const res = await Vue.request.get(`${resource}/${params[resource + '_id']}`, { params: params.params || {} })
      if (res.data.success && params.callback) {
        commit('setCase', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo ${resourceName}.` }) }
      console.error(e)
    }
  },
  async create ({ commit }, params) {
    try {
      const res = await Vue.request.post(`${resource}`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error creando ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error creando ${resourceName}.` }) }
      console.error(e)
    }
  },
  async update ({ commit }, params) {
    try {
      if(!params[resource + '_id']) return;
      const res = await Vue.request.patch(`${resource}/${params[resource + '_id']}`, params)
      if (res.data.success && params.callback) {
        const { status } = res.data.resource
        const caseStatuses = conversation.getters.selectedStatuses()
        if ((!caseStatuses.length && status !== 'open') || (caseStatuses.length && !caseStatuses.includes(status))) {
          commit('group/removeCase', res.data.resource, { root: true })
        }
        store.dispatch('admin/countTodayCases', {
          admin_id: getCurrentUser().admin_id,
          params: { account_id: res.data.resource.account_id }
        }).then()
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando ${resourceName}.` }) }
      console.error(e)
    }
  },
  async destroy ({ commit }, params) {
    try {
      const res = await Vue.request.delete(`${resource}/${params[resource + '_id']}`, { data: params })
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error eliminando ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error eliminando ${resourceName}.` }) }
      console.error(e)
    }
  },
  async case_groups ({ commit }, params) {
    try {
      const res = await Vue.request.get(`account/${params.account_id}/${resource}_groups`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo grupo de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo grupo de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async update_buk ({ commit }, params) {
    try {
      const res = await Vue.request.patch(`${resource}/update_buk`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando buk de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando buk de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async messages ({ commit }, params) {
    try {
      if (!params.case_id) {
        console.log(`case_id not found ${params.case_id}`)
        return
      }
      let res = await Vue.request.get(`${resource}/${params[resource + '_id']}/messages`, params)
      if (params.params.page == 1) commit('setMessages', [])
      if(res.data.success && params.callback) {
        commit('concatMessages', res.data.resource)
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo mensajes de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo mensajes de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async resolve ({ commit }, params) {
    try {
      const res = await Vue.request.post(`${resource}/${params[resource + '_id']}/resolve`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error resolviendo ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error resolviendo ${resourceName}.` }) }
      console.error(e)
    }
  },
  async take ({ commit }, params) {
    try {
      const res = await Vue.request.post(`${resource}/${params[resource + '_id']}/take`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error tomando ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error tomando ${resourceName}.` }) }
      console.error(e)
    }
  },
  async user_info ({ commit }, params) {
    try {
      const res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/user_info`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando info de usuario de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando info de usuario de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async notes ({ commit }, params) {
    try {
      const res = await Vue.request.get(`${resource}/${params[resource + '_id']}/notes`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando notas de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando notas de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async tags ({ commit }, params) {
    try {
      const res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/tags`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando etiquetas de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando etiquetas de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async assign ({ commit }, params) {
    try {
      const res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/assign`, params)
      if (res.data.success && params.callback) {
        const { case_id: caseId, admin_assigned_id: adminAssignedId } = res.data.resource
        commit('group/updateCaseData', { case_id: caseId, key: 'admin_assigned_id', value: adminAssignedId }, { root: true })
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando admin de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando admin de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async derivate ({ commit }, params) {
    try {
      const res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/derivate`, params)
      if (res.data.success && params.callback) {
        commit('group/removeCase', res.data.resource, { root: true })
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando grupo de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando grupo de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async status ({ commit }, params) {
    try {
      const res = await Vue.request.patch(`${resource}/${params[resource + '_id']}/status`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando estado de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando estado de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async bulk_tags ({ commit }, params) {
    try {
      const res = await Vue.request.patch(`${resource}/bulkTags`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando estado de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando estado de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async bulk_assing ({ commit }, params) {
    try {
      const res = await Vue.request.patch(`${resource}/bulkAssing`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando estado de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando estado de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async bulk_derivate ({ commit }, params) {
    try {
      const res = await Vue.request.patch(`${resource}/bulkDerivate`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error actualizando estado de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error actualizando estado de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async sessions ({ commit }, params) {
    try {
      const res = await Vue.request.get(`${resource}/${params[resource + '_id']}/sessions`, { params: params.params || {} })
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo sesión de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo sesión de ${resourceName}.` }) }
      console.error(e)
    }
  },
  async sessions_summary ({ commit }, params) {
    try {
      const res = await Vue.request_cases.get(`${resource}s/${params.account_id}`, { params: params.params || {} })
      if (res.status === 200 && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo resumen de ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo resumen de ${resourceName}.` }) }
      console.error(e)
    }
  },
}

// functions receive state
const mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  concatItems (state, items) {
    state[resource + 's'] = state[resource + 's'].concat(items)
  },
  pushItem (state, item) {
    state[resource + 's'].push(item)
  },
  setCase (state, item) {
    state.case_object = item
    state.case_object.platform = item.platform || ''
  },
  setMessages (state, items) {
    state.messages = items.reverse()
  },
  concatMessages (state, items) {
    items.forEach(m => {
      state.messages.unshift(m)
    })
  },
  pushMessage (state, message) {
    state.messages.push(message)
  },
  updateStatus (state, status) {
    state.case_object.status = status
  },
  updating (state, isUpdating) {
    clearTimeout(state.timeout)
    state.isUpdating = isUpdating !== undefined ? isUpdating : true

    if (state.isUpdating) {
      state.timeout = setTimeout(() => {
        state.isUpdating = false
      }, 1000 * 10)
    }
  },
  removeTag (state, tagId) {
    if (state.case_object.Tags) {
      const index = state.case_object.Tags.findIndex(t => t.tag_id === tagId)
      if (index >= 0) {
        state.case_object.Tags.splice(index, 1)
      }
    }
  },
  filtersUnread (state, unread) {
    state.filters.unread = unread
  },
  filtersPlatforms (state, platforms) {
    state.filters.platforms = platforms
  },
  filtersGroups(state, groups) {
    state.filters.groups = groups
  },
  removefilterPlatform (state, name) {
    const index = state.filters.platforms.findIndex(p => p.name === name)
    if (index >= 0) {
      state.filters.platforms.splice(index, 1)
    }
  },
  filtersAdmins (state, admins) {
    state.filters.admins = admins
  },
  removefilterAdmin (state, adminId) {
    const index = state.filters.admins.findIndex(a => a.admin_id === adminId)
    if (index >= 0) {
      state.filters.admins.splice(index, 1)
    }
  },
  filtersCaseStatuses (state, status) {
    const index = state.filters.case_statuses.findIndex(s => s === status.value)

    if (status.event === false) {
      if (index >= 0) state.filters.case_statuses.splice(index, 1)
    } else {
      if (index === -1) state.filters.case_statuses.push(status.value)
    }
  },
  filtersDates (state, dates) {
    state.filters.dates.updatedAt = dates ? Vue.prototype.$moment(dates.startDate).startOf('day').format('YYYY-MM-DD') : null
    state.filters.dates.updatedAtEnd = dates ? Vue.prototype.$moment(dates.endDate).endOf('day').format('YYYY-MM-DD') : null
  },
  filterTypes (state, event) {
    const index = state.case_events_filters[event.filter].findIndex(e => e === event.type)

    if (event.value === false) {
      if (index >= 0) state.case_events_filters[event.filter].splice(index, 1)
    } else {
      if (index === -1) state.case_events_filters[event.filter].push(event.type)
    }
    if (state.case_events_filters.event_names.length && !state.case_events_filters.event_types.includes('case_message')) {
      state.case_events_filters.event_types.push('case_message')
    }
  },
  filtersCaseType(state, type) {
    state.filters.caseType = type
  },
  resetAllFilters (state) {
    state.filters = {
      unread: false,
      caseType: { value: 'all', name: 'Todos' },
      case_statuses: [],
      platforms: [],
      groups: [],
      admins: [],
      dates: {
        updatedAt: null,
        updatedAtEnd: null,
        last_message_tim: null,
        last_message_time_end: null
      }
    }
    state.case_events_filters = {
      event_types: [],
      event_names: []
    }
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}

const getCurrentUser = function () {
  const user = Vue.prototype.$getCookie('user')
  if (user) {
    return user
  } else {
    return {}
  }
}
